// extracted by mini-css-extract-plugin
module.exports = {"offsetTwentyRight":"misc_offsetTwentyRight__2pT9j","textCenter":"misc_textCenter__2_7Hj","textLeft":"misc_textLeft__1nIAf"};